/**
 * nutmeg-category-scrolly.js
 * Desktop: Pinned scroll-driven horizontal slider
 * Mobile: CSS scroll-snap, JS only updates active state + handles arrows
 */

(function () {
  'use strict';

  function initSingleSection(outer) {
    var sticky      = outer.querySelector('.nm-cat-scrolly-sticky');
    var track       = outer.querySelector('.nm-cat-track');
    var trackClip   = outer.querySelector('.nm-cat-track-clip');
    var items       = outer.querySelectorAll('.nm-cat-item');
    var bgNumbers   = outer.querySelectorAll('.nm-cat-bg-text');
    var detailsPanes= outer.querySelectorAll('.nm-cat-details-pane');
    var dots        = outer.querySelectorAll('.nm-cat-dot');

    if (!sticky || !track || !items.length) return;

    var slideCount = items.length;
    var LERP       = 0.08;
    var currentX   = 0;
    var targetX    = 0;
    var rafId      = null;
    var activeIndex = 0;
    var isMobile   = false;

    // Desktop-only dimensions
    var vw, vh, leftW, maxScroll, itemW, totalTravel;

    /* =====================================================
       SHARED: UPDATE ACTIVE STATE (dots, panes, bg text)
       ===================================================== */
    function updateActiveState(index) {
      if (index < 0 || index >= slideCount) return;
      activeIndex = index;

      items.forEach(function (item, idx) {
        if (idx === index) item.classList.add('nm-active');
        else item.classList.remove('nm-active');
      });
      bgNumbers.forEach(function (num, idx) {
        if (idx === index) num.classList.add('nm-active');
        else num.classList.remove('nm-active');
      });
      detailsPanes.forEach(function (pane, idx) {
        if (idx === index) pane.classList.add('nm-active');
        else pane.classList.remove('nm-active');
      });
      dots.forEach(function (dot, idx) {
        if (idx === index) dot.classList.add('nm-active');
        else dot.classList.remove('nm-active');
      });
    }

    /* =====================================================
       DESKTOP: Compute sizes
       ===================================================== */
    function computeSizes() {
      vw = window.innerWidth;
      vh = window.innerHeight;
      isMobile = vw <= 991;

      if (isMobile) {
        /* Clear ALL inline styles JS may have set so CSS takes over */
        sticky.style.cssText = '';
        outer.style.cssText  = '';
        track.style.width    = '';
        track.style.transform = '';
        track.style.paddingLeft  = '';
        track.style.paddingRight = '';
        items.forEach(function (item) {
          item.style.width = '';
          var img = item.querySelector('img') || item.querySelector('.placeholder-svg');
          if (img) { img.style.transform = ''; img.style.opacity = ''; }
        });
        return;
      }

      // Desktop layout
      leftW = trackClip.offsetWidth || trackClip.getBoundingClientRect().width || vw * 0.55;
      itemW = leftW * 0.65;
      totalTravel = (slideCount - 1) * itemW;

      var paddingOffset = (leftW - itemW) / 2;
      track.style.paddingLeft  = paddingOffset + 'px';
      track.style.paddingRight = paddingOffset + 'px';
      track.style.width = (slideCount * itemW + leftW - itemW) + 'px';

      items.forEach(function (item) { item.style.width = itemW + 'px'; });

      sticky.style.height = vh + 'px';

      var startBuffer = vh * 0.5;
      var endBuffer   = vh * 0.4;
      maxScroll = startBuffer + ((slideCount - 1) * vh) + endBuffer;
      outer.style.height = (vh + maxScroll) + 'px';

      currentX = 0;
      targetX  = 0;
      track.style.transform = 'translateX(-' + currentX.toFixed(2) + 'px)';
      updateScales(currentX);
    }

    /* =====================================================
       DESKTOP: Scale cards based on proximity
       ===================================================== */
    function updateScales(curX) {
      items.forEach(function (item, index) {
        var itemLeft = index * itemW;
        var distance = Math.abs(curX - itemLeft);
        var pct      = distance / itemW;
        var scale    = 1.0 - 0.15 * Math.min(1, pct);
        var opacity  = 1.0 - 0.3  * Math.min(1, pct);
        var img = item.querySelector('img') || item.querySelector('.placeholder-svg');
        if (img) {
          img.style.transform = 'scale(' + scale.toFixed(3) + ')';
          img.style.opacity   = opacity.toFixed(2);
        }
      });
    }

    function lerp(a, b, t) { return a + (b - a) * t; }

    /* =====================================================
       DESKTOP: Animation tick
       ===================================================== */
    function tick() {
      rafId = null;
      if (isMobile) return;

      currentX = lerp(currentX, targetX, LERP);
      track.style.transform = 'translateX(-' + currentX.toFixed(2) + 'px)';
      updateScales(currentX);

      var centerIndex = Math.round(currentX / itemW);
      centerIndex = Math.max(0, Math.min(centerIndex, slideCount - 1));
      if (centerIndex !== activeIndex) updateActiveState(centerIndex);

      if (Math.abs(targetX - currentX) > 0.3) rafId = requestAnimationFrame(tick);
    }

    /* =====================================================
       DESKTOP: Scroll handler
       ===================================================== */
    function onScroll() {
      /* Use live window.innerWidth — cached isMobile can be stale on first load */
      if (window.innerWidth <= 991) return;

      var currentOffsetWidth = trackClip.offsetWidth;
      if (currentOffsetWidth && currentOffsetWidth !== leftW) computeSizes();

      var scrollY      = window.scrollY || window.pageYOffset;
      var rect         = outer.getBoundingClientRect();
      var outerDocTop  = rect.top + scrollY;
      var scrolledInto = scrollY - outerDocTop;

      var startBuffer      = vh * 0.5;
      var activeScrollRange = Math.max(1, (slideCount - 1) * vh);
      var scrollForTranslation = Math.max(0, scrolledInto - startBuffer);
      var scrollPercent        = Math.min(1, scrollForTranslation / activeScrollRange);

      if (scrolledInto < 0) {
        sticky.style.position = 'absolute';
        sticky.style.top      = '0';
        sticky.style.bottom   = '';
        sticky.style.zIndex   = '';
        sticky.style.left     = '0';
        sticky.style.right    = '0';
        sticky.style.width    = '100%';
        targetX = 0;
        document.body.classList.remove('nm-scroll-pinned');
      } else if (scrolledInto < maxScroll) {
        sticky.style.position = 'fixed';
        sticky.style.top      = '0';
        sticky.style.bottom   = '';
        sticky.style.zIndex   = '50';
        sticky.style.left     = '0';
        sticky.style.right    = '0';
        sticky.style.width    = '100%';
        targetX = scrollPercent * totalTravel;
        document.body.classList.add('nm-scroll-pinned');
      } else {
        sticky.style.position = 'absolute';
        sticky.style.top      = '';
        sticky.style.bottom   = '0';
        sticky.style.zIndex   = '';
        sticky.style.left     = '0';
        sticky.style.right    = '0';
        sticky.style.width    = '100%';
        targetX = totalTravel;
        document.body.classList.remove('nm-scroll-pinned');
      }

      if (!rafId) rafId = requestAnimationFrame(tick);
    }

    /* =====================================================
       MOBILE: IntersectionObserver watches each item
       Lower threshold (0.4) so it fires while swiping mid-way
       ===================================================== */
    var mobileObserver = null;

    function initMobileObserver() {
      if (!('IntersectionObserver' in window)) return;
      mobileObserver = new IntersectionObserver(function (entries) {
        /* Pick the most-intersecting entry */
        var best = null;
        entries.forEach(function (entry) {
          if (!best || entry.intersectionRatio > best.intersectionRatio) best = entry;
        });
        if (best && best.intersectionRatio >= 0.4) {
          var index = parseInt(best.target.getAttribute('data-index'), 10);
          if (!isNaN(index)) updateActiveState(index);
        }
      }, { root: trackClip, threshold: [0, 0.25, 0.4, 0.6, 0.75, 1.0] });

      items.forEach(function (item) { mobileObserver.observe(item); });
    }

    function destroyMobileObserver() {
      if (mobileObserver) { mobileObserver.disconnect(); mobileObserver = null; }
    }

    /* =====================================================
       MOBILE: Arrow navigation — smooth infinite loop
       Instead of jumping, we scroll to the target index.
       On first/last edge we do a quick invisible reset.
       ===================================================== */
    function scrollToSlide(index) {
      if (!trackClip || !items[index]) return;
      /* Scroll so the item's left edge aligns with the clip container left */
      trackClip.scrollTo({ left: items[index].offsetLeft, behavior: 'smooth' });
    }

    var prevArrow = outer.querySelector('.nm-cat-mobile-arrow-prev');
    var nextArrow = outer.querySelector('.nm-cat-mobile-arrow-next');

    if (prevArrow) {
      prevArrow.addEventListener('click', function () {
        if (!isMobile) return;
        if (activeIndex <= 0) {
          /* At first: instantly jump to last without animation, then it feels looped */
          trackClip.scrollTo({ left: items[slideCount - 1].offsetLeft, behavior: 'instant' });
          updateActiveState(slideCount - 1);
        } else {
          scrollToSlide(activeIndex - 1);
        }
      });
    }

    if (nextArrow) {
      nextArrow.addEventListener('click', function () {
        if (!isMobile) return;
        if (activeIndex >= slideCount - 1) {
          /* At last: instantly jump to first without animation */
          trackClip.scrollTo({ left: 0, behavior: 'instant' });
          updateActiveState(0);
        } else {
          scrollToSlide(activeIndex + 1);
        }
      });
    }

    /* Dots */
    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        var index = parseInt(dot.getAttribute('data-index'), 10);
        if (isMobile) {
          scrollToSlide(index);
        } else {
          var scrollY     = window.scrollY || window.pageYOffset;
          var rect        = outer.getBoundingClientRect();
          var outerDocTop = rect.top + scrollY;
          window.scrollTo({ top: outerDocTop + (index * vh), behavior: 'smooth' });
        }
      });
    });

    /* =====================================================
       RESIZE
       ===================================================== */
    function onResize() {
      computeSizes();
      if (isMobile) {
        destroyMobileObserver();
        initMobileObserver();
      } else {
        destroyMobileObserver();
        onScroll();
      }
    }

    /* =====================================================
       INIT
       ===================================================== */
    computeSizes();
    if (isMobile) {
      initMobileObserver();
      /* Ensure first slide is active */
      updateActiveState(0);
    } else {
      onScroll();
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    var resizeListener = function () {
      clearTimeout(window._nmCatResizeTimer);
      window._nmCatResizeTimer = setTimeout(onResize, 150);
    };
    window.addEventListener('resize', resizeListener, { passive: true });

    outer._cleanupListeners = function () {
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', resizeListener);
      destroyMobileObserver();
    };
  }

  function init() {
    var outers = document.querySelectorAll('.nm-cat-scrolly-outer');
    outers.forEach(function (outer) {
      if (outer.dataset.initialized === 'true') {
        if (typeof outer._cleanupListeners === 'function') outer._cleanupListeners();
      }
      outer.dataset.initialized = 'true';
      initSingleSection(outer);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function () { init(); });

})();
